export default {
  install ($Vue, runtimeConstants) {
    /* istanbul ignore next: it's hard to test $runtimeConstants existing */
    if (!('$runtimeConstants' in $Vue.prototype)) {
      Object.defineProperty($Vue.prototype, '$runtimeConstants', {
        get () {
          return Object.freeze(runtimeConstants);
        },
      });
    }
  },
};
